<template>
  <div>
    <div class="alert alert-success mb-0" v-show="success">{{ success }}</div>
    <div class="alert alert-danger mb-0" v-show="error">{{ error }}</div>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="row">
          <form id="form" :action="api+'api/v1/update/reseller/'+this.$route.params.id">
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.custom_reseller_panel.reseller_info }} </div>
                <div class="card-block">
                  <input type="hidden" name="id" value="2240">
                  <div class="form-group">
                    <label for="">{{ t.name }}</label>
                    <input type="text" name="name" v-model="u.firstName" class="form-control" maxlength="30" required="">
                  </div>
                  <div class="form-group" style="display: none;">
                    <label for="">Haftalık Limit</label>
                    <input type="number" name="weekly_limit" v-model="u.weeklyLimit" class="form-control" required="" placeholder="Bayinin haftalık sabit limiti" value="0">
                  </div>
                  <div class="form-group" style="display: none;">
                    <label for="">Güncel Limit</label>
                    <input type="number" name="current_limit" v-model="u.currentLimit" class="form-control" required="" placeholder="Bayinin güncel limiti" value="0">
                  </div>
                  <div class="form-group">
                    <label for="">{{ t.user.telephone }}</label>
                    <input type="text" name="phone" class="form-control" v-model="u.phoneS" maxlength="15" value="">
                  </div>
                  <div class="form-group">
                    <label for="">{{ t.details }}</label>
                    <textarea name="detail" class="form-control" rows="5" v-model="u.note"></textarea>
                  </div>
                  <div class="form-group" style="display: none;">
                    <div class="toggle btn btn-success" data-toggle="toggle" style="width: 115.383px; height: 35.5px;">
                      <input type="checkbox" name="atim_cekim" checked="" data-toggle="toggle" data-on="Atım Aktif" data-off="Atım Pasif" data-onstyle="success" data-offstyle="danger">
                      <div class="toggle-group">
                        <label class="btn btn-success toggle-on">Atım Aktif</label>
                        <label class="btn btn-danger active toggle-off">Atım Pasif</label>
                        <span class="toggle-handle btn btn-default"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card" v-if="u.hasOwnProperty('disabled_providers')">
                <div class="card-header"> Casino </div>
                <div class="card-block" :class="(providerToggle) ? 'opened' : 'closed'">
                  <div class="form-check mt-2" v-for="p in providers">
                    <label class="form-check-label">
                      <input @click="updateProvider(p.id)" type="checkbox" class="form-check-input" :checked="checkProvider(p.id)"/>
                      {{ p.name }}
                    </label>
                  </div>
                  <input type="hidden" name="disabled_provider" :value="disabledProviders.join(',')"/>
                </div>
                <a class="btn" @click="toggle()">{{ t.all }}</a>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.details }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.user.username }}</label>
                    <input type="text" name="username" class="form-control" v-model="u.username" maxlength="20" required="" placeholder="Bayinin sisteme giriş kullanıcı adı">
                  </div>
                  <div class="form-group">
                    <label for="">{{ t.user.password }}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="password" maxlength="20" v-model="password">
                      <span class="input-group-btn">
                        <button class="btn btn-link" type="button" id="generatePassword" @click="generatePasswordFx()">{{ t.custom_reseller_panel.generate_password }}</button>
                        <span id="generatePasswordEditMode"></span>
                      </span>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">Cashback Percent %</label>
                    <input type="number" max="20" min="0" name="cashback_percent" class="form-control" v-model="u.cashbackPercent" required="" placeholder="Bayinin sisteme giriş kullanıcı adı">
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header"> {{ t.navigation.roles }} </div>
                <div class="card-block">
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="active" checked=""> {{ t.custom_reseller_panel.is_active }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input v-if="u.roles" class="form-check-input" type="checkbox" name="role_user_status" :checked="(u.roles.includes('ROLE_USER_STATUS')) ? 'checked' : ''"> {{ t.custom_reseller_panel.role_account_enable }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input v-if="u.roles" class="form-check-input" type="checkbox" name="role_money_transfer" :checked="(u.roles.includes('ROLE_USER_STATUS')) ? 'checked' : ''"> {{ t.custom_reseller_panel.role_money_transfer }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input v-if="u.roles" class="form-check-input" type="checkbox" name="role_user_pass_reset" :checked="(u.roles.includes('ROLE_USER_PASS_RESET')) ? 'checked' : ''"> {{ t.custom_reseller_panel.role_password_reset }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input v-if="u.roles" class="form-check-input" type="checkbox" name="role_betslip_configuration" :checked="(u.roles.includes('ROLE_BETSLIP_CONFIGURATION')) ? 'checked' : ''"> {{ t.custom_reseller_panel.role_betslip_configuration || 'Betslip Limits' }} </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card card-block">
                <button type="submit" class="btn btn-success" id="form-submit-button">{{ t.edit_and_save }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerSearch from "../CustomerSearch";
export default {
  name: "ResellerCreate",
  components: {CustomerSearch},
  data () {
    return {
      api: window.api,
      t: this.$root.t,
      error: null,
      success: null,
      password: null,
      u: {},
      dealer_id: null,
      providers: [],
      disabledProviders: [],
      providerToggle: false
    }
  },
  mounted() {
    this.submitForm()
  
    this.fetchCasinoProviders()
  },
  methods: {
    toggle() {
        this.providerToggle = (this.providerToggle) ? false : true
    },
    updateProvider(pid) {

        var i = this.disabledProviders.indexOf(pid);
        if( i !== -1) {
          this.disabledProviders.splice(i)
        }else {
          this.disabledProviders.push(pid)
        }

    },
    checkProvider(pid) {

      return (this.disabledProviders && this.disabledProviders.indexOf(pid) !== -1) ? false : true
    },
    fetchCasinoProviders() {
      this.$http.get(api + 'api/v1/casino/providers',
          {params: this.$route.query})
          .then(response => {
            this.providers = response.body.result;
            this.fetchReseller()
          }, response => {
      })
    },
    fetchReseller(){
      this.$http.get(api + 'api/v1/users?uid=' + this.$route.params.id)
          .then(response => {
            this.u = response.body.result.users[0];
            this.disabledProviders = this.u.disabled_providers.split(",").map(function(t){return parseInt(t)})

          }, response => {

            this.u = null
          })
    },
    generatePasswordFx(){
      var number = this.generatePassword(10);

      this.password = number;
    },
    findUser(u){
      this.dealer_id = u.id;
    },
    submitForm(){
      const form = document.querySelector("#form");
      form.addEventListener("submit", e => {
        e.preventDefault();
        const fd = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", e => {

          if(e.currentTarget.status === 200)
            this.$router.replace({name: 'ResellerList'})

          if(e.currentTarget.status === 400){
            this.error = JSON.parse(e.target.responseText).error;

            setTimeout(() => {
              this.error = null;
            }, 5000)
          }
        });
        xhr.addEventListener("error", e => {
          console.log(e);
          this.error = JSON.parse(e.target.responseText).error;
        });
        xhr.open("POST", form.action);
        //xhr.setRequestHeader('Accept-Language', session.locale.locale)
        xhr.setRequestHeader('Authorization', 'Bearer ' + window.auth.accessToken)
        xhr.send(fd);
      });
    },
  }
}
</script>

<style scoped>
.closed {
  height: 190px;
  overflow: hidden;
}
.opened {
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/views/ResellerUpdate.vue